/**
 * A picked file as base64, for a JSON body. ⭐ One copy for every dialog that reads a document the
 * operator attaches (LP1.3's lease read, the 100th's OM read). `readAsDataURL` rather than `btoa`
 * over the bytes: a 10 MB PDF spread into `String.fromCharCode` overflows the call stack.
 */
export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.onerror = () => reject(new Error(`Could not read ${file.name}`));
    reader.readAsDataURL(file);
  });
